<template>
  <div class="pricing-price-tag">
    <div class="pricing-item-price mb-4">
      <span class="pricing-item-price-currency h3">{{currencySymbol}}</span>
      <template v-if="pricingSwitchOn">
        <span class="pricing-item-price-amount h1">{{lowPrice | asCurrency}}</span>
        <span class="text-sm">&nbsp;/entire project</span>
      </template>
      <template v-if="!pricingSwitchOn">
        <span
          class="pricing-item-price-amount h1"
          :title="'Total project price = ' + currencySymbol + highPrice.toLocaleString()"
        >{{highPrice / numPhases | asCurrency}}</span>
        <span
          class="text-sm"
          :title="'Total project price = ' + currencySymbol + highPrice.toLocaleString()"
        ></span>
        <span v-if="numPhases && numPhases > 1">&nbsp;/phase x {{numPhases}} phases</span>
        <span v-else>&nbsp;total</span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "PriceTag",
  components: {},
  props: {
    currencySymbol: {type: String, default: "$"},
    pricingSwitchOn: {
      type: Boolean,
      default: true,
    },
    lowPrice: { type: Number, default: 0 },
    highPrice: { type: Number, default: 0 },
    numPhases: { type: Number, default: 2 },
  },
  data() {
    return {}
  },
  computed: {
  },
  created(){
  },
  methods: {
   
  },
  mounted() {},
};
</script>
